import styled from 'styled-components';

export const MenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 20px;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

export const MenuHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background: transparent;
`;

export const Logo = styled.img`
  height: 2.5rem;
  width: auto;
  margin-right: 1rem;
  object-fit: contain;
  filter: none;
  opacity: 1;
`;

export const MenuItems = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
`;

export const RightMenuItems = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  height: 100%;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
  color: #32363A;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  gap: 8px;
  height: 100%;
  position: relative;

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    min-width: 200px;
    margin-top: 4px;
    z-index: 1000;
    padding: 4px 0;
    display: block;
  }

  .dropdown-item {
    padding: 12px 16px;
    color: #32363A;
    transition: all 0.2s ease;
    white-space: nowrap;
    cursor: pointer;

  }

  svg {
    width: 16px;
    height: 16px;
    color: #6A6D70;
    transition: all 0.2s ease;
  }

  &:hover {
    background: #F7F7F7;
    color: #32363A;
  }

  &.active {
    color: #0A6ED1;
    font-weight: 500;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: #0A6ED1;
    }

    svg {
      color: #0A6ED1;
    }
  }

  .notification-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 8px;
    height: 8px;
    background: #E52929;
    border-radius: 50%;
    border: 2px solid #ffffff;
  }

  &.profile-button {
    padding: 0 8px;
  }

  .profile-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
  }

  .profile-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    min-width: 200px;
    margin-top: 4px;
    z-index: 1000;
  }

  .profile-item {
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #32363A;
    transition: all 0.2s ease;

    &:hover {
      background: #F7F7F7;
      color: #0A6ED1;
    }
  }

  @media (max-width: 768px) {
    padding: 0 12px;
    
    span {
      display: none;
    }
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: #32363A;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background: #F7F7F7;
    color: #0A6ED1;
  }

  svg {
    color: #6A6D70;
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileMenu = styled.div<{ isOpen: boolean }>`
  display: none;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  background: #ffffff;
  padding: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  z-index: 999;
  transition: all 0.3s ease;

  ${({ isOpen }) => isOpen && `
    display: block;
  `}

  ${MenuItem} {
    padding: 12px 16px;
    border-radius: 4px;
    margin: 4px 0;

    &:hover {
      background: #F7F7F7;
    }

    &.active {
      background: #F7F7F7;
      color: #0A6ED1;

      &::after {
        display: none;
      }
    }

    span {
      display: inline-block;
    }

    &.sub-item {
      padding-left: 32px;
      font-size: 13px;
      color: #666;
    }
  }

  .mobile-dropdown {
    background: #f8f9fa;
    border-radius: 4px;
    margin: 0 8px 8px;
    overflow: hidden;
  }
`;

export const SideBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 48px;
  height: 100vh;
  background: #fff;
  border-right: 1px solid #eee;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1100;
`;

export const MenuButton = styled.button`
  margin-top: 12px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 22px;
`;

export const TopBar = styled.div`
  position: fixed;
  top: 0;
  left: 48px;
  right: 0;
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

export const NavItems = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  .nav-item {
    font-weight: 500;
    cursor: pointer;
    padding: 8px 0;
    border-bottom: 2px solid transparent;
    &.active {
      color: #0A6ED1;
      border-bottom: 2px solid #0A6ED1;
    }
    &.dropdown {
      display: flex;
      align-items: center;
    }
  }
`;

export const RightItems = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  .profile-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #0A6ED1;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
  }
`; 